import Vue from 'vue'
import VueRouter from 'vue-router'

import login from '../views/login/login'
import myUser from "@/views/home/myUser";
import user from "@/views/home/user"

  const index =()=> import ('../views/home/index')
  import userList from '@/views/home/userList'
// const login = () => import("../views/login/login")

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: index
  },
  {path:'*',redirect:'/'},
  ,{
    path: '/index',
    name: 'index',
    component: index
  },{
    path: '/user/:id?',
    name: 'user',
    component: user
  },{
    path: '/myUser',
    name: 'myUser',
    component: myUser
  },{
    path: '/userList/:id?',
    name: 'userList',
    component: userList
  },{
    path: '/login',
    name: 'login',
    component: login
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router

// router.beforeEach((to, from, next) => {
//   if (to.path === '/login') {
//     next();
//   } else {
//     if(to.path === '/index' || to.path==='/'){
//       let a = this.$route.query.code
//        localStorage.setItem("authorization",a)
//       let token = localStorage.getItem('authorization');
//       console.log("tokne",a);
//       if (token === null || token === '') {
//         next('/login')
//       } else {
//         next();
//       }
//     }

// }
// });
